<template>
  <div class="main-window-l">
    <div class="step-nav">
      <div class="nav-item active">
        <span class="sort">1</span>志愿者报名
      </div>
      <span :class="['split-line', { 'active': second || thir }]"></span>
      <div :class="['nav-item', { 'active': second || thir }]">
        <span class="sort">2</span>报名信息确认
      </div>
      <span :class="['split-line', { 'active': thir }]"></span>
      <div :class="['nav-item', { 'active': thir }]">
        <span class="sort">3</span>完成
      </div>
    </div>

    <div v-if="!thir" class="inviteCenter ipts">
      <div class="title">个人信息（*项为必填项）
        <span v-if="isReadOnly">{{ enrollStatus }}</span>
      </div>
      <div class="list">
        <div class="centerItem">
          <div class="center-item-half">
            <label class="name">姓名*</label>
            <template v-if="fir">
              <input id="fullName" placeholder="请输入姓名" class="txtin inputRequired" v-model="formData.fullName"
                autocomplete="off" />
            </template>
            <label v-if="second" class="look">{{ formData.fullName }}</label>
          </div>
          <div style="display:flex;align-items:center">
            <label class="name">性别*</label>
            <template v-if="fir">
              <input v-model="formData.sex" value="1" class="radio_dot" type="radio" name="sexRadio" />男
              <input v-model="formData.sex" value="2" class="radio_dot" type="radio" name="sexRadio" />女
            </template>
            <label v-if="second" class="look">{{ formData.sex == 1 ? '男' : '女' }}</label>
          </div>
        </div>
        <div class="centerItem">
          <div class="center-item-half">
            <label class="name">民族*</label>
            <template v-if="fir">
              <input id="nation" placeholder="请输入民族" class="txtin inputRequired" v-model="formData.nation"
                autocomplete="off" />
            </template>
            <label v-if="second" class="look">{{ formData.nation }}</label>
          </div>
          <div style="display:flex;align-items:center">
            <label class="name">籍贯*</label>
            <template v-if="fir">
              <input id="registeredResidence" placeholder="请输入籍贯" class="txtin inputRequired"
                v-model="formData.registeredResidence" autocomplete="off" />
            </template>
            <label v-if="second" class="look">{{ formData.registeredResidence }}</label>
          </div>
        </div>
        <div class="centerItem">
          <div class="center-item-half">
            <label class="name">身份证号*</label>
            <template v-if="fir">
              <input id="certNo" placeholder="请输入身份证号" class="txtin inputRequired" v-model="formData.certNo"
                autocomplete="off" />
            </template>
            <label v-if="second" class="look">{{ formData.certNo }}</label>
          </div>
          <div style="display:flex;align-items:center">
            <label class="name">出生年月*</label>
            <date-select :fir="fir" :second="second" :initDateTime="formData.birthday" :date-show="false"
              @getDate="getDate" />
          </div>
        </div>
        <div class="centerItem">
          <div class="center-item-half">
            <label class="name">身高（CM）*</label>
            <template v-if="fir">
              <input id="height" placeholder="请输入身高" class="txtin inputRequired" v-model="formData.height"
                autocomplete="off" />
            </template>
            <label v-if="second" class="look">{{ formData.height }}</label>
          </div>
          <div style="display:flex;align-items:center">
            <label class="name">体重（KG）*</label>
            <template v-if="fir">
              <input id="weight" placeholder="请输入体重" class="txtin inputRequired" v-model="formData.weight"
                autocomplete="off" />
            </template>
            <label v-if="second" class="look">{{ formData.weight }}</label>
          </div>
        </div>
        <div class="centerItem">
          <label class="name">户籍所在地*</label>
          <template v-if="fir">
            <input id="residenceAddress" placeholder="请输入户籍所在地" class="txtin2 inputRequired"
              v-model="formData.residenceAddress" autocomplete="off" />
          </template>
          <label v-if="second" class="look">{{ formData.residenceAddress }}</label>
        </div>
        <div class="centerItem">
          <div style="display:flex">
            <label class="name">现居住地*</label>
            <textarea :class="['inputRequired', second ? 'look2' : 'txtArea']" placeholder="请输入现居住地" maxlength="300"
              v-model="formData.presentAddress" :readonly="second"></textarea>
          </div>
        </div>
        <div class="centerItem">
          <div class="center-item-half">
            <label class="name">手机号*</label>
            <template v-if="!isReadOnly && fir">
              <input id="mobile" placeholder="请输入手机号" class="txtin inputRequired" v-model="formData.mobile"
                autocomplete="off" />
            </template>
            <label v-if="isReadOnly || second" class="look">{{ formData.mobile }}</label>
          </div>
          <div style="display:flex;align-items:center">
            <label class="name">邮箱*</label>
            <template v-if="fir">
              <input id="email" placeholder="请输入邮箱" class="txtin inputRequired" v-model="formData.email"
                autocomplete="off" />
            </template>
            <label v-if="second" class="look">{{ formData.email }}</label>
          </div>
        </div>
        <div class="centerItem">
          <label class="name name-auto">学习经历（从高中开始）*</label>
        </div>
        <template v-for="(item, index) in formData.learnList">
          <div :key="'learn' + index" class="centerItem" style="align-items: unset">
            <label class="name"></label>
            <div>
              <div class="centerItem">
                <div style="display:flex;align-items:center">
                  <label class="name">起始时间*</label>
                  <date-select :fir="fir" :second="second" :initDateTime="item.startTime" :date-show="false"
                    @getDate="getListDate($event, 'startTime', item)" />
                </div>
              </div>
              <div class="centerItem">
                <div style="display:flex;align-items:center">
                  <label class="name">截至时间*</label>
                  <date-select :fir="fir" :second="second" :initDateTime="item.endTime" :date-show="false"
                    @getDate="getListDate($event, 'endTime', item)" />
                  <div v-if="fir" class="time-btn" @click="chooseNowT(item)">至今</div>
                </div>
              </div>
              <div class="centerItem">
                <label class="name">学校*</label>
                <input v-if="fir" placeholder="请输入学校" class="txtin inputRequired" v-model="item.school"
                  autocomplete="off" />
                <label v-if="second" class="look">{{ item.school }}</label>
              </div>
              <div class="centerItem">
                <label class="name">专业*</label>
                <input v-if="fir" placeholder="请输入专业" class="txtin inputRequired" v-model="item.major"
                  autocomplete="off" />
                <label v-if="second" class="look">{{ item.major }}</label>
              </div>
              <div class="centerItem margin-b-0">
                <label class="name">学历*</label>
                <input v-if="fir" placeholder="请输入学历" class="txtin inputRequired" v-model="item.education"
                  autocomplete="off" />
                <label v-if="second" class="look">{{ item.education }}</label>
              </div>
            </div>
            <div v-if="fir" class="form-right-btn">
              <img v-if="formData.learnList.length > 1" src="@/static/img/del.png"
                @click="modifyLearnMsg('del', index)" />
              <img v-if="index == formData.learnList.length - 1" src="@/static/img/add.png"
                @click="modifyLearnMsg('add', index)" />
            </div>
          </div>
        </template>
        <div class="centerItem">
          <label class="name name-auto">工作（实习）经历/志愿服务经历*</label>
        </div>
        <template v-for="(item, index) in formData.internshipList">
          <div :key="'internship' + index" class="centerItem" style="align-items: unset">
            <label class="name"></label>
            <div>
              <div class="centerItem">
                <div style="display:flex;align-items:center">
                  <label class="name">起始时间*</label>
                  <date-select :fir="fir" :second="second" :initDateTime="item.startTime" :date-show="false"
                    @getDate="getListDate($event, 'startTime', item)" />
                </div>
              </div>
              <div class="centerItem">
                <div style="display:flex;align-items:center">
                  <label class="name">截至时间*</label>
                  <date-select :fir="fir" :second="second" :initDateTime="item.endTime" :date-show="false"
                    @getDate="getListDate($event, 'endTime', item)" />
                  <div v-if="fir" class="time-btn" @click="chooseNowT(item)">至今</div>
                </div>
              </div>
              <div class="centerItem">
                <label class="name name-auto">单位或服务机构*</label>
                <input v-if="fir" placeholder="请输入" class="txtin inputRequired" v-model="item.company"
                  autocomplete="off" />
                <label v-if="second" class="look">{{ item.company }}</label>
              </div>
              <div class="centerItem">
                <label class="name">部门及岗位*</label>
                <input v-if="fir" placeholder="请输入" class="txtin inputRequired" v-model="item.department"
                  autocomplete="off" />
                <label v-if="second" class="look">{{ item.department }}</label>
              </div>
              <div class="centerItem margin-b-0">
                <label class="name">参与项目*</label>
                <input v-if="fir" placeholder="请输入" class="txtin inputRequired" v-model="item.project"
                  autocomplete="off" />
                <label v-if="second" class="look">{{ item.project }}</label>
              </div>
            </div>
            <div v-if="fir" class="form-right-btn">
              <img v-if="formData.internshipList.length > 1" src="@/static/img/del.png"
                @click="modifyInternshipMsg('del', index)" />
              <img v-if="index == formData.internshipList.length - 1" src="@/static/img/add.png"
                @click="modifyInternshipMsg('add', index)" />
            </div>
          </div>
        </template>
        <div class="centerItem">
          <div style="display:flex">
            <label class="name">获奖经历</label>
            <textarea :class="[second ? 'look2' : 'txtArea']" placeholder="请输入获奖经历" maxlength="300"
              v-model="formData.awardExperience" :readonly="second"></textarea>
          </div>
        </div>
        <div class="centerItem">
          <div style="display:flex;align-items:center">
            <label class="name">上岗时间*</label>
            <template v-if="fir">
              <div v-for="(item, index) in workTime" :key="index" class="margin-r-30">
                <input v-model="formData.workDate" :value="item" class="radio_dot" type="radio"
                  name="workDateRadio" />{{ item }}
              </div>
            </template>
            <label v-if="second" class="look">{{ formData.workDate }}</label>
          </div>
        </div>
        <div id="intendedServiceGroup" class="centerItem">
          <label class="name">意向服务组别*</label>
          <select v-if="fir" class="types margin-r-30" v-model="intendedServiceGroupParent">
            <option v-for="(item, index) in intendedServiceGroupParentArr" :key="index" :value="item">{{ item }}
            </option>
          </select>
          <select v-if="fir" class="types" :disabled="intendedServiceGroupParent == ''"
            v-model="intendedServiceGroupChild">
            <option v-for="(item, index) in intendedServiceGroupChildArr" :key="index" :value="item">{{ item }}</option>
          </select>
          <label v-if="second" class="look">{{ formData.intendedServiceGroup }}</label>
        </div>
        <div class="centerItem">
          <div style="display:flex;align-items:center">
            <label class="name">服从调剂*</label>
            <template v-if="fir">
              <input v-model="formData.isAdjust" value="1" class="radio_dot" type="radio" name="isAdjustRadio" />是
              <input v-model="formData.isAdjust" value="0" class="radio_dot" type="radio" name="isAdjustRadio" />否
            </template>
            <label v-if="second" class="look">{{ formData.isAdjust == 1 ? '是' : '否' }}</label>
          </div>
        </div>
        <div class="centerItem">
          <div style="display:flex">
            <label class="name">请简单描述您希望成为中国金鸡百花奖电影节志愿者的理由（100字以内）*</label>
            <textarea :class="['inputRequired', second ? 'look2' : 'txtArea']" placeholder="请输入" maxlength="100"
              v-model="formData.enrollReason" :readonly="second"></textarea>
          </div>
        </div>
      </div>

      <div class="title">附件上传</div>
      <div class="list">
        <div class="margin-b-20">
          <label class="name name-auto">个人照片（一寸）*</label>
          <span class="remind-text">（支持jpg、jpeg、png）</span>
          <upload-file :isReadonly="second" upType="img" :beforeFile="inchPhotoFiles"
            @getUploadFile="getUploadFile($event, 'inchPhoto')"></upload-file>
        </div>
        <div class="margin-b-20">
          <label class="name">作品</label>
        </div>
        <div v-for="(item, index) in formData.worksList" :key="'works' + index">
          <div class="centerItem" style="align-items: unset">
            <label class="name"></label>
            <div>
              <div class="centerItem margin-b-0">
                <label class="name">类型</label>
                <template v-if="fir">
                  <template v-for="item0 in workTypes">
                    <input :key="item0.id" v-model="item.worksType" :value="item0.id" :name="'worksTypeRadio' + index"
                      class="radio_dot" type="radio" />{{ item0.name }}
                  </template>
                </template>
                <label v-if="second" class="look">{{ item.worksType | worksTypeFilter }}</label>
              </div>
            </div>
            <div v-if="fir" class="form-right-btn">
              <img v-if="formData.worksList.length > 1" src="@/static/img/del.png"
                @click="modifyWorksMsg('del', index)" />
              <img v-if="index == formData.worksList.length - 1" src="@/static/img/add.png"
                @click="modifyWorksMsg('add', index)" />
            </div>
          </div>
          <div class="centerItem">
            <label class="name"></label>
            <div v-if="item.worksType === 1">
              <label class="name">视频链接</label>
              <template v-if="fir">
                <input placeholder="请输入" class="txtin" v-model="item.worksContent" autocomplete="off" />
              </template>
              <label v-if="second" class="look">{{ formData.worksContent }}</label>
            </div>
            <div v-if="item.worksType === 2">
              <label class="name">图片</label>
              <span class="remind-text">（支持jpg、jpeg、png）</span>
              <upload-file :isReadonly="second" upType="img" :beforeFile="item.imgList"
                @getUploadFile="getListUploadFile($event, 'imgList', item)"></upload-file>
            </div>
            <div v-if="item.worksType === 3">
              <label class="name">文档</label>
              <span class="remind-text">（仅支持pdf）</span>
              <upload-file :isReadonly="second" upType="pdf" :beforeFile="item.fileList"
                @getUploadFile="getListUploadFile($event, 'fileList', item)"></upload-file>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content" v-if="thir">
      <div class="suc-remind">
        <img src="@/static/img/jj_gou.png" />
        <p>完成报名，请等待工作人员审核报名信息</p>
        <p style="font-size: 16px">
          <span>{{ jumpT }}</span>s跳转到个人中心…
        </p>
      </div>
    </div>

    <div v-if="!thir" :class="['foo', { 'foo-center': fir }]">
      <button v-if="fir" class="rightBtn" @click="next">下一步</button>
      <div v-if="second">
        <button class="leftBtn" @click="pre">返回修改</button>
        <button class="rightBtn" :disabled="isSubmit" @click="submit">确认{{ submitText }}</button>
      </div>
    </div>

    <el-dialog :visible.sync="showTip" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false"
      center title="申报须知" width="800px">
      <notice-content />
      <span slot="footer">
        <button :class="['rightBtn', countdown > 0 ? 'disabled width-auto' : '']" @click="agreeBtn">
          已阅读并同意
          <span v-if="countdown > 0">（{{ countdown }}S）</span>
        </button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { volunteer } from "@/api/volunteer.js";
import DateSelect from "@/views/components/DateSelect";
import UploadFile from "@/views/components/UploadFile";
import NoticeContent from './components/notice';

const groupObj = {
  '活动运营中心': ['大型活动组', '影展组', '创投论坛组'],
  '宣传中心': ['宣传编辑组', '图片视频组'],
  '品牌中心': [],
  '综合保障中心': [],
  '专业技能中心': ['影展字幕组', '影展技术组']
}

var _this;

export default {
  components: { DateSelect, UploadFile, NoticeContent },
  data() {
    return {
      jumpT: 3,
      fir: true,
      second: false,
      thir: false,
      isSubmit: false,

      showTip: false,
      countdown: 10,
      isReadOnly: false,
      enrollStatus: '',
      submitText: '提交',
      // 上岗时间
      workTime: ['即刻上岗-11月中上旬', '10月8日-11月中上旬', '10月24日-11月中上旬'],
      // 作品类型
      workTypes: [{
        id: 1,
        name: '视频'
      }, {
        id: 2,
        name: '图片'
      }, {
        id: 3,
        name: '文档'
      }],
      // 允许上传文件类型
      inchPhotoFiles: [],
      formData: {
        enrollStatus: "0",
        fullName: "",
        sex: "1",
        nation: "",
        registeredResidence: "",
        residenceAddress: "",
        presentAddress: "",
        mobile: "",
        certNo: "",
        email: "",
        birthday: null,
        height: "",
        weight: "",
        workDate: "",
        intendedServiceGroup: "",
        isAdjust: null,
        enrollReason: "",
        awardExperience: "",
        inchPhoto: "",
        internshipList: [{
          startTime: null,
          endTime: null,
          company: '',
          department: '',
          project: ''
        }],
        learnList: [{
          startTime: null,
          endTime: null,
          school: '',
          major: '',
          education: ''
        }],
        worksList: [{
          worksType: '',
          worksContent: '',
          imgList: [],
          fileList: []
        }]
      },
      showDatePicker: false,
      currentDate: new Date(),
      minDate: new Date(new Date().getFullYear() - 100, 0, 1),
      maxDate: new Date(),
      timePickerObj: {
        type: '',
        list: '',
        index: ''
      },
      showGroupPicker: false,
      intendedServiceGroupParent: '',
      intendedServiceGroupChild: '',
      intendedServiceGroupParentArr: [],
      intendedServiceGroupChildArr: []
    };
  },
  filters: {
    worksTypeFilter(val) {
      const obj = _this.workTypes.find(item => item.id === val);
      return obj ? obj.name : val;
    }
  },
  watch: {
    intendedServiceGroupParent(newVal) {
      this.intendedServiceGroupChild = ''
      this.intendedServiceGroupChildArr = groupObj[newVal]
    }
  },
  beforeCreate() {
    _this = this;
  },
  created() {
    // this.$msgbox({
    //   title: "提示",
    //   message: "报名时间已截止",
    //   showClose: false,
    //   confirmButtonClass: "btn-color",
    //   closeOnClickModal: false,
    //   closeOnPressEscape: false,
    //   callback: (action, instance) => {
    //     if (action == "confirm") {
    //       this.$router.replace('/volunteer/login');
    //     }
    //   }
    // });
    if (this.$cookies.isKey("token") && this.$session.get("userInfo")) {
      this.isReadOnly = true;
      this.submitText = '修改';
      this.initData();
    } else {
      this.showTip = true;
      let countdownInterval = setInterval(() => {
        this.countdown--;
        if (this.countdown === 0) {
          clearInterval(countdownInterval);
        }
      }, 1000);
    }
    this.intendedServiceGroupParentArr = Object.keys(groupObj);
  },
  methods: {
    initData() {
      this.formData = this.$session.get("userInfo");

      // 审核状态
      this.enrollStatus = this.formData.enrollStatus === '0' ? '待审核' : '审核中';

      // 是否服从调剂
      this.formData.isAdjust = this.formData.isAdjust ? 1 : 0;

      // 学习经历
      this.formData.learnList.forEach(item => {
        this.$set(item, 'startTime', new Date(item.startTime).getTime());
        if (item.endTime) {
          this.$set(item, 'endTime', new Date(item.endTime).getTime());
        }
      })

      // 工作经历
      this.formData.internshipList.forEach(item => {
        this.$set(item, 'startTime', new Date(item.startTime).getTime());
        if (item.endTime) {
          this.$set(item, 'endTime', new Date(item.endTime).getTime());
        }
      })
    },
    agreeBtn() {
      if (this.countdown === 0) {
        this.showTip = false;
      }
    },
    getDate(val) {
      this.formData.birthday = val;
    },
    getListDate(val, type, item) {
      this.$set(item, type, val);
    },
    chooseNowT(obj) {
      const nowT = new Date().getTime();
      this.$set(obj, 'endTime', nowT);
    },
    modifyLearnMsg(type, index) {
      switch (type) {
        case 'del':
          this.formData.learnList.splice(index, 1)
          break
        case 'add':
          this.formData.learnList.push({
            startTime: null,
            endTime: null,
            school: '',
            major: '',
            education: ''
          })
          break
      }
    },
    modifyInternshipMsg(type, index) {
      switch (type) {
        case 'del':
          this.formData.internshipList.splice(index, 1)
          break
        case 'add':
          this.formData.internshipList.push({
            startTime: null,
            endTime: null,
            company: '',
            department: '',
            project: ''
          })
          break
      }
    },
    modifyWorksMsg(type, index) {
      switch (type) {
        case 'del':
          this.formData.worksList.splice(index, 1)
          break
        case 'add':
          this.formData.worksList.push({
            worksType: '',
            worksContent: '',
            imgList: [],
            fileList: []
          })
          break
      }
    },
    // 上传照片
    getUploadFile(e, type) {
      if (e[0]) {
        this.formData[type] = e[0].objectId;
      }
    },
    getListUploadFile(e, type, obj) {
      if (e[0]) {
        this.$set(obj, type, e[0].objectId);
      }
    },
    sortList(list) {
      let sortList = [];
      list.forEach((item, index) => {
        sortList.push({
          ...item,
          sort: index + 1
        })
      })
      return sortList
    },
    pre() {
      if (this.second) {
        this.fir = true;
        this.second = false;
      }
    },
    // 下一页
    next() {
      let str = this.intendedServiceGroupParent;
      if (this.intendedServiceGroupChild) {
        str += `-${this.intendedServiceGroupChild}`;
      }
      this.formData.intendedServiceGroup = str;

      this.fir = false;
      this.second = true;
    },
    async submit() {
      this.isSubmit = true;
      const params = {
        mainId: this.$session.get("cmm").mainId,
        enrollType: 2,
        ...this.formData,
        learnList: this.sortList(this.formData.learnList),
        internshipList: this.sortList(this.formData.internshipList),
        worksList: this.sortList(this.formData.worksList)
      }
      let res = null;

      try {
        if (this.isReadOnly) {
          res = await volunteer.updateInfo(params);
        } else {
          res = await volunteer.enroll(params);
        }
        this.isSubmit = false;
        if (res.code == 200) {
          this.second = false;
          this.thir = true;
          setInterval(() => {
            this.jumpT--;
            if (this.jumpT == 0) {
              this.$router.push({ name: "volunteer" });
            }
          }, 1000);
        }
      } catch (err) {
        this.isSubmit = false;
      }
    }
  }
};
</script>

<style src="../../static/css/regist.css" scoped></style>
<style scoped>
.inviteCenter .list {
  padding-left: 130px;
}

.name {
  width: 130px;
}

.name-auto {
  margin-right: 20px;
  width: auto;
  min-width: 130px;
}

.width-auto {
  width: auto;
}

.time-btn {
  margin-left: 20px;
  color: #C1A17B;
  cursor: pointer;
}

.form-right-btn {
  width: 250px;
  text-align: right;
}

.form-right-btn img {
  margin-left: 10px;
  width: 25px;
  cursor: pointer;
}

.center-item-half {
  width: calc(50% - 65px);
}
</style>